import { render, staticRenderFns } from "./AddVariantNavigation.vue?vue&type=template&id=4ff7358d&lang=pug"
import script from "./AddVariantNavigation.vue?vue&type=script&lang=js"
export * from "./AddVariantNavigation.vue?vue&type=script&lang=js"
import style0 from "./AddVariantNavigation.vue?vue&type=style&index=0&id=4ff7358d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports